<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f0YBed/images/9781466834972.jpg?1726444428133" alt="This image is the cover for the book Conan the Swordsman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Conan the Swordsman
      </h1>
      <p class="bookDescription body article font2">
        <p>Imagine a world of gods and demons, where men are warriors, women are beautiful, life is a fantastic adventure, and the fate of kingdoms balances on the bloody blade of a fabulous hero: Conan of the iron thews, the blue-eyed barbarian giant who towers above the savage Hyborian world.<br/><br/>This is the work that relaunched Conan in both the 1970s and 80s, back in print after more than a decade.<br/><br/>Come live the adventure again.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sprague L. de Camp, Lin Carter, Björn Nyberg
      </h2>
      
      <p class="authorDescription body article"><P><B>L. Sprague de Camp</B>, a SFWA Grand Master and winner of the World Fantasy Award for Life Achievement, wrote the definitive biography of Conan's creator, Robert E. Howard. De Camp died in 2000.<br><br><B>Lin Carter </B>was the key figure behind the popular Ballantine Adult Fantasy Series of the 1970s. He died in 1988.<br><br><B>Björn</B> Nyberg</B> first began collaborating with de Camp on Conan works in the 1950s. He lives in France.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?af3bc882